module.exports = __webpack_public_path__ + "img/aysan-ozel.18a5ffc1.jpg";